// Identifiers inside a mixed cell ("MSC ALEXANDRA FE442S", "CNSHA → IDTPP"). A whole identifier column uses
// the column's `mono` flag instead. Both follow the table density, so the density yes/no stays one line.
import type * as React from 'react';
import { createContext, useContext } from 'react';

import { cn } from '@/lib/utils';
import { DEFAULT_TABLE_DENSITY, DENSITY } from './density';
import type { DataTableDensity } from './types';

export const DataTableDensityContext = createContext<DataTableDensity>(DEFAULT_TABLE_DENSITY);

export function DataTableMono({ className, ...props }: React.ComponentProps<'span'>) {
  const density = useContext(DataTableDensityContext);
  return (
    <span data-slot="data-table-mono" className={cn('tabular-nums', DENSITY[density].mono, className)} {...props} />
  );
}
